import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import { Row, Col, Card } from "react-bootstrap";
import { StateContext } from "../../contexts/StateContext";
import { getOrders } from "../../api/api-pizza.js";
import { itemPrice, priceEUR, getIngredients } from "../../helper/functions";

const OrderHistory = () => {
  const { user } = useContext(StateContext);
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (!orders) {
      getOrders((res) => {
        res = res.orders.filter((order) => order.userId === user._id);
        setOrders(res);
      });
    }
  }, []);

  const printDate = (date) => {
    date = new Date(date);
    return date.toLocaleString("sl-SI");
  };

  return (
    <div className="h-100 scrollable overflow-auto m-0">
      <Col className="m-auto" style={{ width: "80%" }}>
        <Card className="mt-2">
          <Row className="m-0">
            <h5 className="align-middle mt-1 text-success">Order History</h5>
            <hr className="border border-dark" />
            {orders &&
              orders.map((order, i) => (
                <Row className="m-auto pb-3" key={i}>
                  <Row>
                    <h6>Date of order {printDate(order.createdAt)}</h6>
                  </Row>
                  {order.cart.items.map((item, j) => (
                    <div key={j}>
                      <Row className="align-center">
                        <Col>
                          <h5 className="mt-2">{item.dough.name}</h5>
                        </Col>
                        <Col>
                          <div className="float-end mt-2 me-2">
                            Pieces: {item.count}
                          </div>
                        </Col>
                        <Col>
                          <div className="float-end mt-2 me-2">
                            {priceEUR(itemPrice(item))}
                          </div>
                        </Col>
                      </Row>
                      <div>{getIngredients(item.ingredients)}</div>
                    </div>
                  ))}
                  <div>
                    <Row className="align-center">
                      <Col>
                        <h6 className="mt-2">Delivery</h6>
                      </Col>
                      <Col>
                        <div className="float-end mt-2 me-2">
                          {priceEUR(order.cart.delivery)}
                        </div>
                      </Col>
                    </Row>
                    <Row className="align-center">
                      <Col>
                        <h6 className="mt-2">
                          <b>TOTAL</b>
                        </h6>
                      </Col>
                      <Col>
                        <div className="float-end mt-2 me-2">
                          {priceEUR(order.price)}
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <hr />
                </Row>
              ))}
          </Row>
        </Card>
      </Col>
    </div>
  );
};

export default OrderHistory;
